import React from "react";
import Formulario from "./pages/Formulario";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        
          <Route path="voluntariado" element={<Formulario color = "#F85A40" product="GV" />} />
          <Route path="talento" element={<Formulario color = "#0CB9C1" product="GTa"/>} />
          <Route path="profesor" element={<Formulario color="#F48924" product="GTe" />} />
          <Route path="*" element={<Navigate to="voluntariado" replace />} />
     
      </Routes>
    </BrowserRouter>
  );
}

export default App;
